exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-danger{color:#dc3545!important;font-weight:700}.badge-expired{background-color:#dc3545;color:#fff}", ""]);

// exports
